import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import { shouldTranslateTo } from '../../../utils/utils';
import { decode } from 'html-entities';

const BackgroundBlur = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.65);
  z-index: 9999999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  cursor: pointer;
`;

const ModalDiv = styled.div`
  background-color: white;
  padding: 40px;
  max-width: 900px;
  width: 100%;
  display: flex;
  border-radius: 4px;
  gap: 40px;
  cursor: default;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 20px;
    gap: 20px;
  }
`;

const ContentSide = styled.div`
  flex: 1;
  max-width: 460px;
  width: 100%;

  h3 {
    font-size: 1.25rem;
    margin-bottom: 16px;
  }

  p {
    margin-bottom: 16px;
    font-size: 16px;
  }

  @media (max-width: 768px) {
    max-width: 100%;

    p:last-of-type {
      display: none;
    }
  }
`;

const ImageSide = styled.div`
  width: 400px;
  height: 600px;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    width: 100%;
    height: 300px;
    order: -1;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
  }
`;

const VerifyButton = styled.button`
  width: 100%;
  background: #eb5e55;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 14px;
  cursor: pointer;
  margin-top: 20px;

  &:hover {
    background: #eb5e55;
  }
`;

const VerifyModal = ({ isOpen, onClose, onVerify }) => {
  const [translations, setTranslations] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchTranslations = async () => {
      try {
        const language = shouldTranslateTo();
        const response = await axios.get(`/api/page-text/verify-modal/${language}`);

        const translationsMap = response.data.reduce((acc, item) => {
          acc[item.textId] = item.text;
          return acc;
        }, {});
        setTranslations(translationsMap);
      } catch (error) {
        console.error('Error fetching translations:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTranslations();
  }, []);

  const handleBackgroundClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen || isLoading) return null;

  return (
    <BackgroundBlur onClick={handleBackgroundClick}>
      <ModalDiv>
        <ContentSide>
          <h3>{decode(translations[80] || 'Verification required')}</h3>
          <p>{decode(translations[81] || '')}</p>
          <p>{decode(translations[82] || '')}</p>
          <p>{decode(translations[83] || '')}</p>
          <VerifyButton onClick={onVerify}>
            {decode(translations[84] || 'Verify Account')}
          </VerifyButton>
        </ContentSide>
        <ImageSide>
          <img
            src="/images/freebird/verified-members.jpeg"
            alt="Verification banner"
          />
        </ImageSide>
      </ModalDiv>
    </BackgroundBlur>
  );
};

export default VerifyModal;
